<template>
  <section class="drawing-area none ie">
    <img
      v-if="$route.query.event === '0000000039'"
      src="../../assets/images/certificate/frame_vtlh.png"
      alt=""
      class="background-image"
    />
    <img
      v-if="
        $route.query.event === '0000000056' ||
        $route.query.event === '0000000057'
      "
      src="../../assets/images/certificate/frame_vmgc.png"
      alt=""
      class="background-image"
    />
    <img
      v-else
      src="../../assets/images/certificate/frame.png"
      alt=""
      class="background-image"
    />
    <figure class="certificate">
      <img
        src="../../assets/images/certificate/IE/ttl-certificate.png"
        alt="certificate"
      />
    </figure>
    <figure class="tmf-virtualrun">
      <span
        class="event-color-border"
        :style="`background-color: ${dataRunner.certificate_detail.event_color_code};`"
      ></span>
      <img
        src="../../assets/images/certificate/IE/ttl-virtualrun.png"
        alt="tmf virtualrun"
        class="event-logo"
      />
      <span
        class="event-color-border"
        :style="`background-color: ${dataRunner.certificate_detail.event_color_code};`"
      ></span>
    </figure>
    <div class="event">
      <img
        :src="`../../../static/certificate/ie/${dataRunner.certificate_detail.event_image_file}.png`"
        alt=""
        height="205"
      />
      <div
        class="event-name"
        v-html="dataRunner.certificate_detail.nass_event_name"
      ></div>
      <div class="event-detail">
        <dl class="event-detail-list">
          <dt class="detail-team">種目 EVENT</dt>
          <dd class="detail-description">
            {{ dataRunner.certificate_detail.nass_course_name }}
          </dd>
        </dl>
        <dl class="event-detail-list">
          <dt class="detail-team">開催日 DATE</dt>
          <dd class="detail-description">
            {{ dataRunner.text.event_at }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="runner">ランナー</div>
    <div class="name">NAME</div>
    <div id="dw-runner-name" class="runner-name">
      {{ dataRunner.runner.runner_name }}
    </div>
    <div class="record">
      <div class="item-area">
        <div class="item-ja">{{ recordTitleJa }}</div>
        <div class="item-en">{{ recordTitleEn }}</div>
      </div>
      <div class="finish-time">{{ recordValue }}</div>
      <div class="item-area">
        <div class="item-ja">総合ランキング</div>
        <div class="item-en">OVERALL PLACE</div>
      </div>
      <div class="finish-ranking">
        {{ dataRunner.runner.result.total_ranking }}位&nbsp;<span
          class="participants"
          >/{{ dataRunner.runner.result.total_runner_count }}人中</span
        >
      </div>
    </div>
    <div class="category">
      <div class="category-item">
        <div class="category-item-area">
          <div class="category-item-area-lang">
            <div class="ja">男女別ランキング</div>
            <div class="en">PLACE BY GENDER</div>
          </div>
          <div class="category-item-area-lang-detail">
            <div class="ja">
              {{ dataRunner.text.gender.ja }}
            </div>
            <div class="en">
              {{ dataRunner.text.gender.en }}
            </div>
          </div>
        </div>
        <div class="ranking-area">
          {{ dataRunner.runner.result.gender_ranking }}位
          <span class="number-of-participants"
            >/{{ dataRunner.runner.result.gender_runner_count }}人中
          </span>
        </div>
      </div>
      <div class="category-item">
        <div class="category-item-area">
          <div class="category-item-area-lang">
            <div class="ja">年代別ランキング</div>
            <div class="en">PLACE BY AGE GROUP</div>
          </div>
          <div class="category-item-area-lang-detail">
            <div class="ja">
              {{ dataRunner.text.age }}
            </div>
            <div class="en"></div>
          </div>
        </div>
        <div class="ranking-area">
          {{ dataRunner.runner.result.age_ranking }}位
          <span class="number-of-participants"
            >/{{ dataRunner.runner.result.age_runner_count }}人中
          </span>
        </div>
      </div>
      <div class="category-item">
        <div class="category-item-area">
          <div class="category-item-area-lang">
            <div class="ja">居住地別ランキング</div>
            <div class="en">REGION</div>
          </div>
          <div class="category-item-area-lang-detail">
            <div class="ja">
              {{ dataRunner.runner.country_name.ja }}
            </div>
            <div class="en">
              {{ dataRunner.runner.country_name.en }}
            </div>
          </div>
        </div>
        <div class="ranking-area">
          {{ dataRunner.runner.result.area_ranking }}位
          <span class="number-of-participants"
            >/{{ dataRunner.runner.result.area_runner_count }}人中
          </span>
        </div>
      </div>
    </div>
    <div class="organization">
      <div class="race-director">
        <div class="ja">{{
          dataRunner.certificate_detail.organizer_title
        }}</div>
        <div class="en font-english">{{
          dataRunner.certificate_detail.organizer_title_english
        }}</div>
      </div>
      <div class="race-director-name">
        <div class="ja">{{ dataRunner.certificate_detail.organizer }}</div>
        <div class="en font-english">{{
          dataRunner.certificate_detail.organizer_english
        }}</div>
      </div>
      <!-- 2021/12 特別対応（スポンサーイベント） -->
      <img
        v-if="$route.query.event === '0000000024'"
        src="../../assets/images/certificate/sign_rfrc.svg"
        alt=""
        width="442px"
      />
      <img
        src="../../assets/images/certificate/sign.png"
        alt=""
        width="442px"
      />
    </div>
    <figure class="logo-organization">
      <!-- 2021/12 特別対応（スポンサーイベント） -->
      <img
        v-if="$route.query.event === '0000000024'"
        src="../../assets/images/certificate/IE/logo-tmf.png"
        class="hidden"
        alt=""
      />
      <img
        v-else
        src="../../assets/images/certificate/IE/logo-tmf.png"
        alt=""
      />
    </figure>
    <div class="heed">
      <div>
        この記録証はバーチャルランニングイベントにより記録されたものです。
      </div>
      <div>
        *The record displayed is uncertified record from a virtual running
        event.
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    document
      .getElementById("dw-runner-name")
      .classList.remove("dw-multiple-lines-font");
    const length = document.getElementById("dw-runner-name").innerText.length;
    // 日本語に合わせる
    if (length > 20) {
      document
        .getElementById("dw-runner-name")
        .classList.add("dw-multiple-lines-font");
    }
  },
  props: {
    dataRunner: Object,
  },
  computed: {
    isDistanceRecord: function () {
      return this.dataRunner.distance_limit_flg === 0;
    },
    recordTitleJa: function () {
      return this.isDistanceRecord ? "総走行距離" : "フィニッシュタイム";
    },
    recordTitleEn: function () {
      return this.isDistanceRecord ? "TOTAL DISTANCE" : "TIME *uncertified";
    },
    recordValue: function () {
      return this.isDistanceRecord
        ? this.dataRunner.text.total_distance
        : this.dataRunner.text.total_time;
    },
  },
  name: "CertificateInternetExplorer",
};
</script>

<style scoped lang="scss">
$certificate-color: #c9ba87;
$sub-certificate-color: #a8985f;
.drawing-area {
  width: 4093px;
  height: 2894px;
  text-align: center;
  position: relative;
  top: -9999px;
  left: -9999px;
  .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 4093px;
    height: 2894px;
    z-index: -1;
  }
  .certificate {
    padding: 4.5% 0 0 0;
  }
  .tmf-virtualrun {
    margin: 1.75% 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .event-color-border {
      width: 10%;
      height: 0.5em;
    }
    .event-logo {
      margin: 0 1%;
    }
  }
  .event {
    width: 2860px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 4% 0 0 0;
    padding: 0 0 2% 0;
    border-bottom: solid 4px $certificate-color;
    .event-name {
      width: 1300px;
      margin: 0 5% 0 1.2%;
      text-align: left;
      font-size: 50px;
    }
    .event-detail {
      .event-detail-list {
        display: flex;
        align-items: center;

        &:not(:first-of-type) {
          margin: 25px 0 0 0;
        }

        .detail-team {
          min-width: 400px;
          height: 90px;
          margin: 0 6% 0 0;
          padding: 2% 0;
          border: 4px solid $certificate-color;
          color: $certificate-color;
          font-size: 50px;
        }

        .detail-description {
          font-size: 50px;
          white-space: nowrap;
        }
      }
    }
  }
  .runner {
    margin: 2.5% 0 0 0;
    font-size: 70px;
    font-weight: bold;
    color: $sub-certificate-color;
  }
  .name {
    font-size: 60px;
    color: $sub-certificate-color;
  }
  .runner-name {
    display: inline-flex;
    align-items: center;
    max-width: 3000px;
    height: 240px;
    line-height: 1.5;
    border-bottom: 4px solid $certificate-color;
    /*2行になったら66px jsで対応*/
    font-size: 150px;
    font-weight: bold;
    overflow: hidden;
  }
  .dw-multiple-lines-font {
    font-size: 66px;
  }
  .record {
    margin: 3.5% 10% 0 10%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    text-align: left;

    .item-area {
      margin: 0 2.5% 0 0;
      padding: 0 0 0 1.3%;
      border-left: solid 2px $sub-certificate-color;
      color: $sub-certificate-color;

      .item-ja {
        font-size: 70px;
        font-weight: bold;
      }

      .item-en {
        margin: 10px 0 0 0;
        font-size: 50px;
      }
    }

    .finish-time,
    .finish-ranking {
      font-size: 150px;
      font-weight: bold;

      .participants {
        font-size: 60px;
      }
    }
  }
  .category {
    margin: 3.5% 10% 0 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    .category-item {
      flex: 1;
      .category-item-area {
        display: flex;
        color: $sub-certificate-color;
        .category-item-area-lang {
          padding: 0 0 0 4%;
          border-left: solid 2px $sub-certificate-color;
          .ja {
            font-size: 60px;
            font-weight: bold;
          }
          .en {
            font-size: 40px;
          }
        }
        .category-item-area-lang-detail {
          margin: 0 0 0 4%;
          white-space: nowrap;
          .ja {
            font-size: 60px;
            font-weight: bold;
          }
          .en {
            font-size: 40px;
          }
        }
      }
      .ranking-area {
        margin: 4% 0 0 0;
        padding: 0 0 0 4%;
        flex: 1;
        font-size: 80px;
        font-weight: bold;
        .number-of-participants {
          font-size: 50px;
        }
      }
    }
  }
  .organization {
    margin: 4% 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    font-size: 50px;
    .race-director {
      margin: 0 2.5% 0 0;
    }
    .ja {
      font-weight: bold;
    }
  }
  .logo-organization {
    margin: 1% 0 0 0;
    .hidden {
      visibility: hidden;
    }
  }
  .heed {
    margin: 2% 0 0 0;
    display: flex;
    justify-content: center;
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CertificateInternetExplorer.vue